<template>
  <div class="property-alert-create">
    <h1 class="center-text">Create Property Alert</h1>
    <form @submit.prevent="createPropertyAlert">
      <div v-if="apiError" class="error center-element">
        Error: {{ apiErrorMessage }}<br />
      </div>
      <div v-if="isError" class="error center-element">
        Error with form<br />
      </div>
      <div class="form-300 center-element">
        <label>Recipient Name</label><br />
        <input
          v-model.trim="alert.name"
          type="text"
          placeholder="Recipient Name"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Property Name'"
          required
        /><br />
        <label>Email</label><br />
        <input
          v-model.trim="alert.email"
          type="text"
          placeholder="Email"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Email'"
          required
        /><br />
        <div v-if="isEmailError" class="error">
          {{ errorEmailMessage }}<br />
        </div>
        <label>SMS/Text Number (Optional)</label><br />
        <input
          v-model.trim="alert.sms_number"
          type="text"
          placeholder="Mobile Number"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Mobile Number'"
        /><br />
        <button type="submit" class="button button-300">Create Alert</button>
      </div>
    </form>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  data() {
    return {
      alert: {
        property_id: this.$route.params.id,
        name: "",
        email: "",
        sms_number: ""
      },
      isError: false,
      isEmailError: false,
      errorEmailMessage: ""
    };
  },
  computed: {
    apiError() {
      return this.$store.getters.apiError;
    },
    apiErrorMessage() {
      return this.$store.getters.apiErrorMessage;
    }
  },
  created() {
    // this.$store.dispatch('resetAllAPIErrorAndMessages');
    this.isPasswordError = false;
    this.errorPasswordMessage = "";
    this.isError = false;
  },
  methods: {
    createPropertyAlert: function() {
      this.isError = false;
      this.isEmailError = false;
      let reEmailFormat = /^[^@|^\s]+@\S+\.\S+/;
      let resultEmailFormat = reEmailFormat.test(this.alert.email);
      if (!resultEmailFormat) {
        this.isError = true;
        this.isEmailError = true;
        this.errorEmailMessage = "Invalid email entered";
      }
      if (!this.isError) {
        // this.$store.dispatch('createPropertyAlert', this.alert);
      }
    }
  }
};
</script>
